import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import QuoteRepository from "src/repository/QuoteRepository";

export const getSubmittedQuoteList = createAsyncThunk('open_quote_submitted_quote', async (params) => {
    return await new QuoteRepository().getSubmittedQuoteList(params)
});

export const searchQuote = createAsyncThunk('open_quote_search_quote', async (params) => {
    return await new QuoteRepository().searchQuote(params)
});

export const getOpenQuotesList = createAsyncThunk('get_Open_Quote_List', async (quotes) => {
    return await new QuoteRepository().getOpenQuoteList(quotes)
});

const initialState = {
    openQuoteList: {},
    submittedQuoteList: {},
    searchQuoteList: {},
    isSuccessAction: true,
};

const slice = createSlice({
    name: "OpenQuote",
    initialState: initialState,
    reducers: {
        SetClearAllQuote: {
            reducer: (state) => {
                state = initialState;
                return state;
            },
        },
        setIsSuccessAction: {
            reducer: (state, action) => {
                state.isSuccessAction = action.payload;
            },
        }
    },
    extraReducers: {
        [getSubmittedQuoteList.fulfilled]: (state, { payload }) => {
            state.submittedQuoteList = payload;
            return state;
        },
        [searchQuote.fulfilled]: (state, { payload }) => {
            state.searchQuoteList = payload;
            return state;
        },
        [getOpenQuotesList.fulfilled]: (state, { payload }) => {
            state.openQuoteList = payload?.openQuoteList;
            return state;
        },
    },
});

export const {
    setIsSuccessAction,
    SetClearAllQuote
} = slice.actions;

export default slice.reducer;
